import React, { useEffect, useState } from 'react';
import { crmIntegrationApi } from '../../services/api';

const formatDate = (value) => (value ? new Date(value).toLocaleString('pt-BR') : '—');

/** Admin, read-only: CRM accounts linked to this Reports. Never shows secrets. */
const CrmIntegrationTab = () => {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    crmIntegrationApi.listAccounts()
      .then((res) => { if (active) setAccounts(res.data?.accounts || []); })
      .catch((err) => { if (active) setError(err.message || 'Não foi possível carregar as contas do CRM.'); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  return (
    <div className="bg-surface-container-low rounded-xl p-8 shadow-[0_8px_32px_rgba(25,28,30,0.04)] mb-12">
      <h2 className="font-headline font-bold text-2xl text-on-surface mb-2 flex items-center gap-2">
        <span className="material-symbols-outlined text-primary">hub</span> Integração CRM
      </h2>
      <p className="text-secondary text-sm mb-6">
        Contas do CRM vinculadas a este Reports. O vínculo é feito pelo SuperAdmin do hub, ao informar o e-mail do usuário.
        Os segredos nunca são exibidos aqui.
      </p>

      {loading ? (
        <p className="py-4 text-center text-secondary">Carregando contas...</p>
      ) : error ? (
        <p className="py-4 text-center text-error" role="alert">{error}</p>
      ) : accounts.length === 0 ? (
        <p className="py-8 text-center text-secondary">Nenhuma conta do CRM vinculada ainda.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="table w-full">
            <thead>
              <tr className="border-b border-outline-variant/30 text-left text-sm text-secondary">
                <th className="pb-3">Conta (ID)</th>
                <th className="pb-3">Nome</th>
                <th className="pb-3">Usuário dono</th>
                <th className="pb-3">Webhook</th>
                <th className="pb-3">Atualizado em</th>
              </tr>
            </thead>
            <tbody>
              {accounts.map((a) => (
                <tr key={a.chatwootAccountId} className="border-b border-outline-variant/10 text-sm">
                  <td className="py-3 font-bold">{a.chatwootAccountId}</td>
                  <td className="py-3">{a.name || '—'}</td>
                  <td className="py-3">
                    {a.owner ? (
                      <>
                        <span className="font-bold">{a.owner.name}</span>
                        <span className="block text-secondary text-xs">{a.owner.email}</span>
                      </>
                    ) : (
                      <span className="text-error">Sem dono</span>
                    )}
                  </td>
                  <td className="py-3 break-all max-w-xs">{a.webhookUrl || '—'}</td>
                  <td className="py-3 whitespace-nowrap">{formatDate(a.updatedAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default CrmIntegrationTab;
